import adminPermissions from '@/assets/admin-permissions.png';

export default function SecurityShowcase({ t }) {
  return (
    <section className="showcase">
      <div className="container">
        <div id="security" className="reveal showcase-grid">
          <div className="showcase-copy">
            <div className="eyebrow">{t.eyebrow}</div>
            <h2>{t.title}</h2>
            <p className="lead">{t.lead}</p>
            <ul className="checklist">
              {t.points.map((p) => (
                <li key={p}>
                  <span className="check-tile indigo">✓</span>
                  <span className="copy">{p}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="frame">
            <div className="frame-glow" style={{ background: 'radial-gradient(circle, var(--acc1), transparent 70%)' }} />
            <div className="frame-card">
              <div className="frame-dots">
                <span className="dot red" /><span className="dot yellow" /><span className="dot green" />
              </div>
              <img src={adminPermissions} alt={t.shotAlt} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
